import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import i18n from 'i18next';

import { routeFileSelector } from '../../../utilz/i18n';
import { getTransportationModeSelectOptions } from '../../../utilz/transportation-mode-utils';
import { transportationModeData } from '../../screens/Quote/constants';
import FormSelectBox from '../Inputs/FormSelectBox';

const TransportationModeSelector = ({
  placeholder = i18n.t('translation:default.buttons.select'),
  label = i18n.t('translation:procurement.fields.modeOfTender.label'),
  colon,
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  tooltip,
  isDefault = false,
  tabIndex,
  disableValidation = false,
  singleLineMode,
  isMockData,
  dataTestId,
  isRequired = false,
}) => {
  const {
    spotQuoteTransportationModes: { data, progressing: loading },
  } = useSelector((state) => state.common);
  const [options, setOptions] = useState([]);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const getTransportationModeList = useCallback(async () => {
    const options = getTransportationModeSelectOptions(data || []);
    setOptions(options);
  }, [data]);

  useEffect(() => {
    if (editMode && !isMockData) {
      getTransportationModeList();
    }
  }, [editMode, isMockData, getTransportationModeList]);

  const labelValueData = transportationModeData.map((item) => ({ label: item.value, value: item.key }));

  return (
    <FormSelectBox
      loading={loading}
      options={
        isMockData
          ? labelValueData
          : isDefault === true
            ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options]
            : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      isRequired={isRequired}
      rules={rules}
      name={name}
      colon={colon}
      editMode={editMode}
      onChange={onChange}
      tooltip={tooltip}
      tabIndex={tabIndex}
      singleLineMode={singleLineMode}
      disableValidation={disableValidation}
      dataTestId={dataTestId}
    />
  );
};

export default TransportationModeSelector;
